// import ForumToken from './ForumToken.json';
import GuGuToken from './GuGuToken.json';

// export const contractAbi = ForumToken.abi;
// export const contractAddress = '0xf24445b2dbEa310671BdD10c1C6460a59CB2E6F3';

export const contractAbi = GuGuToken.abi;
export const contractAddress = '0x6cee25ddB52b47667E0F1E84D27dB58E5F078B86';
export const contractSymbol = 'GuT';